import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const CardTitle = ({ title, to, onClick, sx, inline = false }) => {
  return (
    <Typography
      component={Link}
      to={to}
      onClick={onClick}
      fontSize={{ xs: 14, lg: 16 }}
      fontWeight={'bold'}
      sx={{
        textDecoration: 'none',
        color: 'inherit',
        ...(inline
          ? { display: 'inline' }
          : {
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: '1.5',
            }),
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
};

export default CardTitle;
